<div>
    <table class="activity-table table table-bordered" style="text-align: right">
        <thead>
            <tr>
                <th>Tax Year</th>
                @if (config().chartType == ActivityPanelModes.totalFMV) {
                    @for (seriesItem of config().series | sortBy : 'asc' : 'propertyTypeSequence'; track seriesItem.name) {
                        <th>{{ seriesItem.name }}</th>
                    }
                }
                @if (config().chartType == ActivityPanelModes.totalTaxes) {
                    @for (seriesItem of config().series; track seriesItem.name) {
                        <th>{{ seriesItem.name }}</th>
                    }
                }
                @if (showColumn('', [ActivityPanelModes.totalFMV, ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit, ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre, ActivityPanelModes.totalTaxes])) {
                    <th>{{ getTotalColumnTitle() }}</th>
                }
                @if (showColumn(PropCharNames.SQFT, [ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit, ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre])) {
                    <th>{{ getColumnTitle(PropCharNames.SQFT) }}</th>
                }
                @if (showColumn(PropCharNames.UNITS, [ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit])) {
                    <th>{{ getColumnTitle(PropCharNames.UNITS) }}</th>
                }
                @if (showColumn(PropCharNames.ACREAGE, [ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre])) {
                    <th>{{ getColumnTitle(PropCharNames.ACREAGE) }}</th>
                }
                @if (showColumn('', ['recentAppeals'])) {
                    <th>Orig MV</th>
                }
                @if (showColumn('', ['recentAppeals'])) {
                    <th>Current MV</th>
                }
                @if (showColumn('', ['recentAppeals'])) {
                    <th>Status</th>
                }
                @if (showColumn('', ['recentAppeals'])) {
                    <th>Savings</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (xAxisCategory of config().xAxis.categories | sortBy: 'desc'; track xAxisCategory) {
                <tr>
                    <td  class="text-center">{{ xAxisCategory }}</td>
                    @if (config().chartType == ActivityPanelModes.totalFMV) {
                        @for (seriesItem of config().series | sortBy : 'asc' : 'propertyTypeSequence'; track seriesItem.name) {
                            <td [ngClass]="{'not-actual': isProjected(seriesItem, xAxisCategory)}">
                                <span>{{ getCellValue(seriesItem, xAxisCategory, false, 0) }}</span>
                            </td>
                        }
                    }
                    @if (config().chartType == ActivityPanelModes.totalTaxes) {
                        @for (seriesItem of config().series; track seriesItem.name) {
                            <td [ngClass]="{'not-actual': isProjected(seriesItem, xAxisCategory)}">
                                <span>{{ getCellValue(seriesItem, xAxisCategory, true, 2) }}</span>
                            </td>
                        }
                    }
                    @if (showColumn('', [ActivityPanelModes.totalFMV, ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit, ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre])) {
                        <td [ngClass]="{'not-actual': isProjectedFmvForSingleYear(xAxisCategory)}">{{ getTotalForSingleYear(xAxisCategory) | currency:'USD' : '' :getPrecision(ActivityPanelModes.totalFMV) }}</td>
                    }
                    @if (showColumn('', [ActivityPanelModes.totalTaxes])) {
                        <td [ngClass]="{'not-actual': isProjectedFmvForSingleYear(xAxisCategory)}">{{ getTotalForSingleYear(xAxisCategory) | currency:'USD' : '$' :getPrecision(ActivityPanelModes.totalFMV) }}</td>
                    }
                    @if (showColumn(PropCharNames.SQFT, [ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit, ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre])) {
                        <td [ngClass]="{'not-actual': isProjectedFmvForSingleYear(xAxisCategory)}">{{ getTotalFmvByPropValueForSingleYear(xAxisCategory, PropCharNames.SQFT) | currency:'USD': '' : '1.2-2' }}</td>
                    }
                    @if (showColumn(PropCharNames.UNITS, [ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit])) {
                        <td [ngClass]="{'not-actual': isProjectedFmvForSingleYear(xAxisCategory)}">{{ getTotalFmvByPropValueForSingleYear(xAxisCategory, PropCharNames.UNITS) | currency:'USD': '' : '1.2-2' }}</td>
                    }
                    @if (showColumn(PropCharNames.ACREAGE, [ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre])) {
                        <td [ngClass]="{'not-actual': isProjectedFmvForSingleYear(xAxisCategory)}">{{ getTotalFmvByPropValueForSingleYear(xAxisCategory, PropCharNames.ACREAGE) | currency:'USD': '' : '1.2-2' }}</td>
                    }
                    @if (showColumn('', ['recentAppeals'])) {
                        <td>{{ getAppealCellValue(xAxisCategory, 'originalFMV') }}</td>
                        <td>{{ getAppealCellValue(xAxisCategory, 'currentFMV') }}</td>
                        <td class="text-center">{{ getAppealCellValue(xAxisCategory, 'appealStatus') }}</td>
                        <td>{{ getAppealCellValue(xAxisCategory, 'savings') }}</td>
                    }
                </tr>
            }
        </tbody>
    </table>

    <div>
        <table class="d-inline-block fw-bold">
            @if (showColumn(PropCharNames.ACREAGE, [ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre])) {
                <tr>
                    <td class="text-right pe-2">{{ getFooterTitle(PropCharNames.ACREAGE) }}:</td>
                    <td>{{ getPropCharValue(PropCharNames.ACREAGE) | number:'1.0-4' }}</td>
                </tr>
            }
            @if (showColumn(PropCharNames.SQFT, [ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit, ActivityPanelModes.landFMVPerSqFt, ActivityPanelModes.landFMVPerAcre])) {
                <tr>
                    <td class="text-right pe-2">{{ getFooterTitle(PropCharNames.SQFT) }}:</td>
                    <td>{{ getPropCharValue(PropCharNames.SQFT) | number:'1.0-0' }}</td>
                </tr>
            }
            @if (showColumn(PropCharNames.UNITS, [ActivityPanelModes.totalFMVPerSqFt, ActivityPanelModes.totalFMVPerUnit])) {
                <tr>
                    <td class="text-right pe-2">{{ getFooterTitle(PropCharNames.UNITS) }}:</td>
                    <td>{{ getPropCharValue(PropCharNames.UNITS) | number:'1.0-0' }}</td>
                </tr>
            }
        </table>

        <div class="float-end">
            @if (!(showingAllYears() || (config().xAxis.categories.length >= config().availableYears.length))) {
                <span class="anchor-style" (click)="loadAllYears()">Show All Years</span>
            }
        </div>
    </div>
</div>
